import { Project, Skill } from "./types";
import ZuneImg from './assets/projects/zune.png';
import KidsKommuneImg from './assets/projects/kidskommune.png';
import FreshpassImg from './assets/projects/freshpass.jpg';

export const PROJECTS: Project[] = [
  {
    id: '1',
    title: 'Kids Kommune',
    description: 'Kids classes & activities platform with bookings, maps, Cashfree Split payments, and vendor portal.',
    fullDescription: 'Built an end-to-end MVP platform for discovering and booking kids classes and activities (currently in beta). Delivered a vendor/admin panel using React + Firebase and a consumer mobile app using Flutter + Firebase, with live bookings, location-based discovery, and complete payment flows.',
    challenge: 'Keeping bookings, payments, and communications in sync across the vendor web app and consumer mobile app — especially payment confirmations, email/WhatsApp notifications, and reliable booking state transitions (including compliant invoice generation).',
    solution: 'Designed a clear booking/payment state machine backed by Firebase (auth + data) and integrated Cashfree end-to-end with server-verified payment updates. Automated email/WhatsApp notifications from authoritative state changes and generated compliant invoices based on finalized payment and booking records.',
    image: KidsKommuneImg,
    tags: ['React', 'Firebase', 'Flutter', 'Cashfree', 'Maps', 'Bookings'],
    link: 'https://kidskommune-staging.web.app/',
    year: '2025'
  },
  {
    id: '2',
    title: 'The Freshpass',
    description: 'Barber booking platform with consumer app, barber console, and Stripe Connect payments.',
    fullDescription: 'Worked as a full-stack developer on The Freshpass (currently in progress), building both the barber console and the consumer app. Implemented a Flutter + Firebase booking system with real-time availability and integrated Stripe Connect for end-to-end payments and payouts. Also set up CI/CD for automated builds and deployments.',
    challenge: 'Designing a reliable booking and payments flow that handles availability, cancellations, and payment state transitions across multiple user roles (consumer and barber).',
    solution: 'Built Firebase-backed booking workflows with clear state management and integrated Stripe Connect for secure, compliant multi-party payment flows.',
    image: FreshpassImg,
    tags: ['Flutter', 'Firebase', 'Stripe Connect', 'Bookings', 'CI/CD', 'Full-Stack'],
    link: 'https://thefreshpass.com/',
    year: '2023'
  },
  {
    id: '3',
    title: 'The Zune',
    description: 'Find people to collaborate with on projects, a fullstack project built with React, Node.js, and MongoDB for fast iteration MVP. Focuses on connecting like-minded developers and creators.',
    fullDescription: 'A personal project currently under development, built as a full-stack web app with a React frontend, Node.js backend, and MongoDB for persistence. Features user profiles, project listings, and real-time messaging for collaboration between developers and creators.',
    challenge: 'Designing a scalable foundation that keeps the UI responsive while evolving features quickly during early development.',
    solution: 'Set up a clean React + Node.js architecture with a MongoDB-backed data layer and a flexible API surface for iterative feature delivery.',
    image: ZuneImg,
    tags: ['React', 'Node.js', 'MongoDB', 'Full-Stack'],
    link: 'https://thezune.com/',
    year: '2025'
  }
];

export const SKILLS: Skill[] = [
  {
    category: 'Web',
    items: ['React', 'TypeScript', 'Redux', 'Tailwind CSS', 'Firebase', 'Node.js']
  },
  {
    category: 'Mobile',
    items: ['Flutter', 'Dart', 'Firebase SDK', 'BLoC', 'Riverpod', 'REST APIs']
  },
  {
    category: 'DevOps & Tools',
    items: ['Docker', 'AWS', 'CI/CD', 'Git', 'Linux']
  }
];
